<span class="label mb-2 d-inline-block">{{ text }}</span>
